import { Button } from "antd";
import useSet from "../../../hooks/common/useSet";
import { API_INTEGRATION, API_REQUEST_PUBLIC_KEY } from "../../../utils/apis";
import styled from "styled-components";
import { useToasts } from "../../../hooks/common/useToasts";
import FormFields from "../../common/FormFields";
import useForm from "../../../hooks/common/useForm";
import { apiIntegrationFields } from "../../../utils/api_integration";
import { useAuth } from "../../../context/AuthContext";
import { useEffect, useState } from "react";
import useGet from "../../../hooks/common/useGet";

const ApiIntegration = () => {
  const {
    error,
    uploadData,
    success: uploadSuccess,
    submitting,
    data: uploadResponse,
  } = useSet();

  const { updateFormValue, form, onChange } = useForm();
  const { user } = useAuth();
  const { loadData, data } = useGet();

  const [iframeUrl, setIframeUrl] = useState<string | null>(null);

  useEffect(() => {
    loadData({ api: API_REQUEST_PUBLIC_KEY, params: { user: user?.id } });
  }, []);

  useEffect(() => {
    if (data?.results?.length) {
      updateFormValue("public_key", data.results[0].public_key);
    }
  }, [data]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    await uploadData({
      api: API_INTEGRATION,
      params: {
        ...form,
        background_color: "#eee",
        public_key: data?.results[0]?.public_key,
        redirect_url: "http://localhost:3000/api-integration/create",
        encrypted_secret: data?.results[0]?.encrypted_secret,
      },
      method: "POST",
    });
  };

  useEffect(() => {
    if (uploadSuccess && uploadResponse) {
      const htmlString =
        uploadResponse?.data || uploadResponse?.html || uploadResponse;
      setIframeUrl(htmlString);
    }
  }, [uploadSuccess, uploadResponse]);

  useToasts({
    success: uploadSuccess,
    error,
    successMessage: "Operation Successful",
  });

  return (
    <Wrapper className="flexColumn gap20">
      {iframeUrl && (
        <iframe
          // src={iframeUrl}
          srcDoc={iframeUrl}
          style={{
            width: "100%",
            height: "700px",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
          sandbox="allow-same-origin allow-forms allow-scripts"
        />
      )}

      {!iframeUrl && (
        <form onSubmit={onSubmit}>
          <div className="whiteBg radius10 p-3">
            <div className="capitalize bold pb-1 flexNullCenter mainColor">
              Make Payment
            </div>

            <FormFields
              fields={apiIntegrationFields}
              updateFormValue={updateFormValue}
              form={form}
              onChange={onChange}
              error={error}
            />
          </div>

          <ButtonWrapper>
            <Button
              type="primary"
              htmlType="submit"
              disabled={submitting}
              loading={submitting}
            >
              {submitting ? "Submitting..." : "Submit"}
            </Button>
          </ButtonWrapper>
        </form>
      )}
    </Wrapper>
  );
};

export default ApiIntegration;

const Wrapper = styled.div`
  padding: 0 20px 20px 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 20px;
  gap: 1rem;
`;
